module.exports = __webpack_public_path__ + "files/c7428772abf4c56712253699c4e7b95c.png";